export default "__VITE_ASSET__44c86cfb__"